import { ChevronLeft, ChevronRight } from "lucide-react";

import { PaginationLink } from "@/components/ui/pagination";
import { cn } from "@/lib/utils";

const PaginationPrevious = ({
  className,
  ...props
}: React.ComponentProps<typeof PaginationLink>) => (
  <PaginationLink
    aria-label="Go to previous page"
    /* @ts-expect-error: incorrect type */
    size="default"
    className={cn("gap-1 border border-zinc-200", className)}
    {...props}
  >
    <ChevronLeft className="h-4 w-4" />
  </PaginationLink>
);
PaginationPrevious.displayName = "PaginationPrevious";

const PaginationNext = ({
  className,
  ...props
}: React.ComponentProps<typeof PaginationLink>) => (
  <PaginationLink
    aria-label="Go to next page"
    /* @ts-expect-error: incorrect type */
    size="default"
    className={cn("gap-1 border border-zinc-200", className)}
    {...props}
  >
    <ChevronRight className="h-4 w-4" />
  </PaginationLink>
);
PaginationNext.displayName = "PaginationNext";

export { PaginationNext, PaginationPrevious };
